import {
  Avatar,
  Grid,
  IconButton,
  Link,
  Tooltip,
  Typography,
} from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import CustomDataGrid from '../../../common/components/dataGrid/CustomDataGrid'
import { Add as AddIcon } from '@mui/icons-material'
import { styled } from '@mui/system'
import jwt_decode from 'jwt-decode'
import {
  setColumnFilters,
  setCompanyId,
  setCustomersList,
  setFilteredRows,
  setServiceProviderTrigger,
} from '../../../store/slice/homeSlice'
import StatusChip from '../../../common/components/mui/Chips'
import FilterAltOutlined from '@mui/icons-material/FilterAltOutlined'
import { useSearchParams } from 'react-router-dom'
import { getAllcustomers } from '../../../api/get/getApi'
import { CustomerColumn } from '../../../common/components/dataGrid/columns/HomeColumns'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import {
  executeWithTryCatch,
  formatDate,
  isResponseSuccess,
  normalizeApiResponse,
} from '../../../helpers/HelperFunctions'
import DashboardLayout from '../../../common/layouts/DashboardLayout'
import { useHomeRedux } from '../Home'
import { setAllProducts, setIsLoading } from '../../../store/slice/commonSlice'
import { COMPANY_STATUS, COMPANY_STATUS_OBJ, TOAST_MESSAGES } from '../../../helpers/Constants';
import { useToastContext } from '../../../App'
import { useCommonRedux } from '../../../store/middlewares/CommonRedux'
import CustomerAnalytics from './components/CustomerAnalytics'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { motion } from 'framer-motion'
import ConfirmationModal from '../../../common/components/custom/modal/modal'
import { FlexBox } from '../../../common/styles/styled-components/StyledContainers'
import { AltigenLogoFlipLoader } from '../../../common/components/loaders/loader'
import { api_DeleteCustomerComany } from '../../../api/WebPortalAPI'
import { setIsOrderActivatedView } from '../../../store/slice/homeSlice';
import OrderActivatedView from '../services/common/components/OrderActivatedView'
import { toggleColumnFilterValue } from '../../../common/components/dataGrid/utils/toggleColumnFilter'
import { getColumnFilterValues, normalizeStatusKey } from '../../../common/components/dataGrid/utils/getColumnFilterValues'
import { useGridFiltering } from '../../../common/components/dataGrid/utils/useGridFiltering'
import ColumnFilterPopover from '../../../common/components/dataGrid/columns/ColumnFilterPopover'

const FlexContainer = styled('div')({
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'space-evenly',
  alignItems: 'center',
})

const Customer = (props) => {
  // hooks
  const { dispatch, state } = useHomeRedux()
  const { state: commonState } = useCommonRedux()
  const { toast } = useToastContext()
  const [searchparams, setSearchparams] = useSearchParams()
  const [selectedRow, setSelectedRow] = useState(null)
  const [isOpenDeleteConfirmation, setOpenDeleteConfirmation] = useState(false)

  const [filterAnchor, setFilterAnchor] = useState(null)
  const [activeColumn, setActiveColumn] = useState(null)

  useEffect(() => {
    dispatch(setColumnFilters({}))
  }, [])
  const handleFilterClick = (event, column) => {
    event.stopPropagation()
    setFilterAnchor(event.currentTarget)
    setActiveColumn(column)
  }

  const toggleFilterValue = (value) => {
    dispatch(
      setColumnFilters({
        ...state.columnFilters,
        [activeColumn]: toggleColumnFilterValue(
          state.columnFilters,
          activeColumn,
          value
        ),
      })
    )
  }
  const COMPANY_STATUS_LOOKUP = Object.entries(COMPANY_STATUS).reduce(
    (acc, [key, value]) => {
      acc[normalizeStatusKey(key)] = value
      return acc
    },
    {}
  )

  const resolveStatusId = (statusValue) => {
    if (typeof statusValue === 'number') return statusValue
    const normalized = normalizeStatusKey(statusValue)
    return COMPANY_STATUS_LOOKUP[normalized]
  }

  const renderCompanyStatus = (statusValue) => {
    const statusId = resolveStatusId(statusValue)
    const statusEntry = COMPANY_STATUS_OBJ.find(
      (s) => s.value === statusId
    )

    if (!statusEntry) {
      return (
        <StatusChip
          label={String(statusValue)}
          variant="outlined"
          color="default"
          isSharp
        />
      )
    }

    return (
      <StatusChip
        label={statusEntry.name}
        variant="outlined"
        color={statusEntry.color}
        isSharp
      />
    )
  }

  //lifeCycles
  useEffect(() => {
    if (!commonState.isDirectCustomer) {
      getCompanyId()
    }
    const OrderActivated = localStorage.getItem('OrderActivated')
    if (OrderActivated === 'true')
      dispatch(setIsOrderActivatedView(true))
  }, [state.isToggleCustomer])


  const getCompanyId = async () => {
    let companyId = ''
    dispatch(setAllProducts(null))
    dispatch(setServiceProviderTrigger('')) //avoid trigger service provider
    const decodeToken = localStorage.getItem('sd_cp.jwt:tkn')
    if (decodeToken) {
      const decoded = jwt_decode(decodeToken)
      if (decoded) {
        companyId = searchparams.get('company_id')
        if (!companyId) {
          companyId = decoded?.company_id
        }
      }
    }
    const response = await getAllcustomers(companyId)
    dispatch(setCustomersList(response.data.result || []))
    dispatch(setCompanyId(companyId))
  }

  const handleSignUpUrlOpen = (url) => {
    window.open(url, '_blank')
  }

  const handleCopy = async (url) => {
    try {
      const permissionStatus = await navigator.permissions.query({
        name: 'clipboard-write',
      })

      if (
        permissionStatus.state === 'granted' ||
        permissionStatus.state === 'prompt'
      ) {
        await navigator.clipboard.writeText(url)
        toast.showToast('Text copied to clipboard successfully!')
      } else {
        toast.showToast('Clipboard write permission denied', 'error')
      }
    } catch (err) {
      toast.showToast('Failed to copy text: ', 'error')
    }
    navigator.clipboard.writeText(url)
  }

  const handleOpenDeleteConfirmation = (row) => {
    setOpenDeleteConfirmation(true)
    setSelectedRow(row)
  }

  const renderCompanyName = (row, value) => {
    return [COMPANY_STATUS.Active, COMPANY_STATUS.ApprovalPending].includes(
      row?.companyStatus
    ) ? (
      <FlexBox>
        <Typography variant="tablePrimary">
          <Link
            underline="none"
            color="primary"
            onClick={() => props?.onRowClick(row)}
          >
            {value}
          </Link>
          <Tooltip title="Copy Login Url">
            <IconButton onClick={() => handleCopy(row?.loginUrl)}>
              <ContentCopyIcon sx={{ fontSize: 14 }} />
            </IconButton>
          </Tooltip>
        </Typography>
        {/* --- Delete Customer part --  */}
        <motion.div whileHover={{ scale: 1.3 }}>
          {commonState.isMaster && (
            <Tooltip title="Delete Customer" placement="right">
              <IconButton
                color="error"
                sx={{ display: 'none' }}
                onClick={() => handleOpenDeleteConfirmation(row)}
              >
                <DeleteOutlineIcon color="error" sx={{ fontSize: 14 }} />
              </IconButton>
            </Tooltip>
          )}
        </motion.div>
      </FlexBox>
    ) : (
      <FlexBox>
        <Typography variant="tablePrimary">
          {value}&nbsp;
          <Tooltip title="Copy Signup Url">
            <IconButton onClick={() => handleCopy(row?.signupUrl)}>
              <ContentCopyIcon sx={{ fontSize: 14 }} />
            </IconButton>
          </Tooltip>
        </Typography>
        {/* --- Delete Customer part --  */}
        <motion.div whileHover={{ scale: 1.3 }}>
          {commonState.isMaster && (
            <Tooltip title="Delete Customer" placement="right">
              <IconButton
                color="error"
                sx={{ display: 'none' }}
                onClick={() => handleOpenDeleteConfirmation(row)}
              >
                <DeleteOutlineIcon color="error" sx={{ fontSize: 14 }} />
              </IconButton>
            </Tooltip>
          )}
        </motion.div>
      </FlexBox>
    )
  }

  //render company
  const renderCompany = (params) => {
    const { row, value, id } = params
    return (
      <FlexContainer sx={{ gap: '1rem' }}>
        <Avatar alt="logo" src={row.logoUrl} sx={{ width: 24, height: 24 }} />
        {renderCompanyName(row, value)}
      </FlexContainer>
    )
  }



  const columnValues = useMemo(() => {
    return getColumnFilterValues({
      rows: state.customersList,
      field: activeColumn,
      statusOptions: COMPANY_STATUS_OBJ,
    })
  }, [activeColumn, state.customersList])
  const columnProps = {
    renderCompany,
    renderCompanyStatus,
    onFilterClick: handleFilterClick,
    activeFilters: state.columnFilters,
  }

  const columns = useMemo(
    () => CustomerColumn(columnProps),
    [columnProps]
  )
  const filteredData = useGridFiltering({
    rows: state.customersList,
    columns,
    searchValue: state.searchValue?.customer,
    columnFilters: state.columnFilters,
    statusField: 'companyStatus',
  })
  const isAnyColumnFiltered = useMemo(
    () =>
      Object.values(state.columnFilters || {}).some(
        (v) => Array.isArray(v) && v.length
      ),
    [state.columnFilters]
  )
  const handleDeleteResellerCustomer = async () => {
    setOpenDeleteConfirmation(false)
    dispatch(setIsLoading(true))
    // TODO: api call to delete customer
    executeWithTryCatch(async () => {
      const response = await api_DeleteCustomerComany({
        companyId: selectedRow.id,
      })
      if (isResponseSuccess(response)) {
        const customers = [...state.customersList]
        const index = customers.findIndex(
          (customer) => customer.id === selectedRow.id
        )
        if (index === -1) return
        customers.splice(index, 1)
        dispatch(setIsLoading(false))
        setTimeout(() => dispatch(setCustomersList(customers)), 1000)
        toast.showToast(TOAST_MESSAGES.CustomerDeleted)
      }
    }, handleDeleteError)
  }

  const handleDeleteError = (error) => {
    dispatch(setIsLoading(false))
    toast.showToast(
      normalizeApiResponse(error)?.message,
      'error'
    )
  }


  return (
    state.isOrderActivatedView ? <OrderActivatedView /> :
      <Grid container>
        {commonState.isLoading && <AltigenLogoFlipLoader />}
        {state.customersList?.length > 0 && (
          <Grid item xs={12} sm={12} md={12}>
            <CustomerAnalytics customersList={state.customersList} />
          </Grid>
        )}
        <Grid item xs={12} sm={12} md={12}>
          <DashboardLayout
            name="Customer"
            buttonStartIcon={<AddIcon />}
            isShowSearch={props.isShowSearch}
            handleButtonClick={(e) => props?.handleShowCompany(e, 'customer')}
            children={
              <CustomDataGrid
                loading={!Array.isArray(state.customersList)}
                isFiltered={isAnyColumnFiltered}
                filteredCount={filteredData.length}
                totalCount={state.customersList.length}
                noDataText="Customer"
                columns={columns}
                data={filteredData}
                searchValue={state.searchValue?.customer}
              />
            }
          />
          <ConfirmationModal
            isOpen={isOpenDeleteConfirmation}
            title="Delete Customer"
            content={
              <span>
                Are you sure you want to delete <b>{selectedRow?.name}</b> ?
              </span>
            }
            btnOk="Delete Customer"
            btnCancel="Cancel"
            handleClose={() => setOpenDeleteConfirmation(false)}
            handleConfirm={handleDeleteResellerCustomer}
            size="sm"
          />
          {activeColumn && (
            <ColumnFilterPopover
              anchorEl={filterAnchor}
              title={`Filter by ${activeColumn}`}
              values={columnValues}
              selectedValues={state.columnFilters[activeColumn] || []}
              onChange={toggleFilterValue}
              onClear={() =>
                dispatch(
                  setColumnFilters({
                    ...state.columnFilters,
                    [activeColumn]: [],
                  })
                )
              }
              onClose={() => {
                setFilterAnchor(null)
                setActiveColumn(null)
              }}
            />
          )}
        </Grid>
      </Grid>
  )
}

export default Customer
